<script setup lang="ts">
  import MultiSelect from 'primevue/multiselect';

  const { name, label, rules } = defineProps({
    name: {
      type: String,
      required: true
    },
    label: {
      type: String,
      required: true
    },
    placeholder: {
      type: String,
      default: undefined
    },
    rules: {
      type: String,
      default: undefined
    },
    items: {
      type: Array as PropType<any[]>,
      default: () => []
    },
    optionLabel: {
      type: String,
      default: undefined
    },
    optionValue: {
      type: String,
      default: undefined
    },
    filterMinItems: {
      type: Number,
      default: 6
    }
  });

  const viewport = useViewport();

  const { value: fieldValue, errorMessage } = useField(name, rules, {
    label: () => label
  });
</script>

<template>
  <div class="form-field w-full">
    <MultiSelect
      v-model="fieldValue"
      :name="name"
      :options="items"
      :option-label="optionLabel"
      :option-value="optionValue"
      :filter="items.length >= filterMinItems"
      :placeholder="placeholder"
      :max-selected-labels="0"
      :show-toggle-all="items.length >= filterMinItems"
      :fluid="true"
      variant="outlined"
      :size="viewport.isLessThan('lg') ? 'small' : 'large'">
      <template #value="{ value: v, placeholder: ph }">
        <template v-if="!v || !v.length">{{ ph }}</template>
        <template v-else>
          {{ placeholder }}
          <span class="text-magenta">({{ v.length }})</span>
        </template>
      </template>
    </MultiSelect>
    <div
      v-if="errorMessage"
      class="form-field__error">
      <span></span>
      <span>{{ errorMessage }}</span>
    </div>
  </div>
</template>
